module.exports = __webpack_public_path__ + "media/npc_dota_hero_pugna.46594fd2.webm";